import React, { useEffect } from 'react';
import { track } from '@amplitude/analytics-browser';
import { Alert, Link } from '@nimbus-ds/components';
import { FormattedMultilineText } from 'commons/components/FormattedMultilineText';
import { useTranslationWithPrefix } from 'commons/utils';
import { PendingTrialPeriodAlertPage } from '../PendingTrialPeriodAlert';

interface InterfaceBlockedAlert {
  page: PendingTrialPeriodAlertPage;
}

const BlockedAlert = ({ page }: InterfaceBlockedAlert): JSX.Element => {
  const { t } = useTranslationWithPrefix(
    'configuration.personalData.kycV2.blocked',
  );

  useEffect(() => {
    track('pago-nube-validacion-bloqueada-view', {
      page,
    });
  }, [page]);

  const handleLinkClick = () => {
    track('pago-nube-validacion-bloqueada-click', {
      page,
    });
  };

  return (
    <Alert appearance="danger" title={t('title')} data-testid="blocked-alert">
      <FormattedMultilineText color="danger-textLow" formattedFontWeight="bold">
        {t('description')}
      </FormattedMultilineText>
      <Link
        as="a"
        href={t('linkUrl')}
        target="_blank"
        rel="noopener noreferrer"
        appearance="primary"
        onClick={handleLinkClick}
      >
        {t('linkText')}
      </Link>
    </Alert>
  );
};

export default BlockedAlert;
